import {
  useQuery,
  type UseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query';

import { ApiResponseError } from '@api/apiUtils/ApiResponseError';
import {
  getActiveUserOptions,
  getUserOptions,
} from '@api/users/api.users.options';

import type {
  CurrentUserFetchResponse,
  UserDescription,
} from './api.users.types';

export const useRetrieveUser = (
  id: string,
): UseQueryResult<UserDescription> => {
  return useQuery(getUserOptions(id));
};

export const useActiveUser = () => {
  return useSuspenseQuery<CurrentUserFetchResponse, ApiResponseError>(
    getActiveUserOptions,
  );
};
